import script from "./PasswordForgotten.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordForgotten.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordForgotten.vue?vue&type=style&index=0&id=db4502f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db4502f8"]])

export default __exports__